import { useRouter } from 'next/router'
import { Header } from '@/elements/header/Header'
import { Footer } from '@/components/elements/footer/Footer'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'
import { ModularLandingPageRecord } from '@/graphql/ModularLandingPage'
import { ModularLandingPageContent } from './ModularLandingPageContent'
import { DSSpacer } from '@zoe/ds-web'
import { useSetTrackingSection } from '@/lib/hooks/useSetTrackingSection'

type ModularLandingPageProps = {
  page: ModularLandingPageRecord
}

export const ModularLandingPage: React.FC<ModularLandingPageProps> = ({ page }) => {
  const router = useRouter()
  const { metaData, pageTitle } = page
  const path = router.asPath
  useSetTrackingSection('modular_landing_page')

  return (
    <>
      <SEOMetaTags metaData={{ ...metaData, title: pageTitle }} path={path} />
      <Header />
      <main>
        <DSSpacer direction="vertical" size={96} />
        <ModularLandingPageContent content={page.pageContent} />
      </main>
      <Footer showPreFooter={page.showPreFooter} />
    </>
  )
}
